import React from "react";
import { motion } from "framer-motion";
import { Seo } from "../components/Seo";

export default function About() {
  return (
    <div data-testid="page-about">
      <Seo
        title="About | SymbiCognitive"
        description="SymbiCognitive is a developing project by Chris Dean, bringing decades of operations and leadership experience to practical, people-first AI adoption in Wisconsin."
        path="/about"
      />
      <section className="bg-midnight pt-20" data-testid="about-hero">
        <div className="max-w-7xl mx-auto px-6 sm:px-10 pt-20 pb-16">
          <span className="text-xs uppercase tracking-[0.2em] font-semibold text-teal">About SymbiCognitive</span>
          <h1 className="font-display font-extrabold text-white text-4xl sm:text-5xl tracking-tight mt-4 max-w-3xl leading-[1.05]">Technology is fascinating. People make it useful.</h1>
        </div>
        <div className="gradient-divider h-1.5 w-full" />
      </section>

      <section className="bg-white py-24 sm:py-28" data-testid="about-body">
        <div className="max-w-3xl mx-auto px-6 sm:px-10">
          <motion.div
            initial={{ opacity: 0, y: 24 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, amount: 0.2 }}
            transition={{ duration: 0.6 }}
            className="space-y-6 text-[var(--slate-soft)] text-lg leading-relaxed"
          >
            <p className="text-slateink font-display font-semibold text-2xl">I'm Christopher Dean.</p>
            <p>For more than three decades, I've worked in business operations, developed teams, and helped organizations improve the way they serve customers and support their people.</p>
            <p>Along the way, I've learned that the best ideas succeed through the people who bring them to life. Leadership matters. Expectations matter. Culture matters. So do the everyday processes that determine whether good intentions become dependable results.</p>
            <p>I've also become deeply interested in artificial intelligence — particularly what happens when we connect increasingly capable technology with practical business experience and a genuine understanding of people.</p>
            <p>SymbiCognitive brings those interests together. It's a developing project, a place for practical experimentation, and an opportunity to share what I'm learning about helping organizations use AI thoughtfully.</p>
            <p>I'm especially interested in the smaller businesses and community organizations that make Wisconsin a good place to live and work.</p>
            <p className="text-slateink font-medium">There's a lot to learn. I'm eager to keep asking good questions.</p>
          </motion.div>
        </div>
      </section>
    </div>
  );
}
